import { useLang } from 'hooks/lang';

import { Column, Row } from 'components/Blocks';
import { CircleAlertIcon } from 'components/Icons';

export function NoInvoice(): JSX.Element {
  const { t } = useLang();

  return (
    <Column gap="6" alignItems="center" justifyContent="center" className="min-h-[30vh]">
      <Row>
        <CircleAlertIcon color="primary" size={48} />

        <h5> {t('no-invoice-found')}</h5>
      </Row>

      <p>{t('as-soon-as-we-have-one-on-this-status')}</p>
    </Column>
  );
}
